import { render, staticRenderFns } from "./AirQuality.vue?vue&type=template&id=1cbb7c76&"
import script from "./AirQuality.vue?vue&type=script&lang=js&"
export * from "./AirQuality.vue?vue&type=script&lang=js&"
import style0 from "./AirQuality.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports